export var Billing;
(function (Billing) {
    Billing[Billing["PerUnit"] = 0] = "PerUnit";
    Billing[Billing["Periodically"] = 1] = "Periodically";
})(Billing || (Billing = {}));
export var Status;
(function (Status) {
    Status["WaitingRespose"] = "WaitingRespose";
    Status["Accepted"] = "Accepted";
    Status["Denied"] = "Denied";
    Status["Withdrawn"] = "Withdrawn";
    Status["AgeRestriction"] = "AgeRestriction";
    Status["NationalIdMismatch"] = "NationalIdMismatch";
})(Status || (Status = {}));
export var State;
(function (State) {
    State["Received"] = "Received";
    State["WaitingForConsent"] = "WaitingForConsent";
    State["WaitingForResearcher"] = "WaitingForResearcher";
    State["ResearchInProgress"] = "ResearchInProgress";
    State["ResearchCompleted"] = "ResearchCompleted";
    State["Delivered"] = "Delivered";
    State["ConsentGiven"] = "ConsentGiven";
    State["ConsentWithdrawn"] = "ConsentWithdrawn";
    State["ConsentDeclined"] = "ConsentDeclined";
    State["Deleted"] = "Deleted";
})(State || (State = {}));
export var UserType;
(function (UserType) {
    UserType["Company"] = "Company";
    UserType["Candidate"] = "Candidate";
    UserType["Internal"] = "Internal";
})(UserType || (UserType = {}));
export var Accrual;
(function (Accrual) {
    Accrual["Weekly"] = "Weekly";
    Accrual["Monthly"] = "Monthly";
    Accrual["Quarterly"] = "Quarterly";
})(Accrual || (Accrual = {}));
export var DeliveryMethodInvoice;
(function (DeliveryMethodInvoice) {
    DeliveryMethodInvoice["Mail"] = "Mail";
    DeliveryMethodInvoice["Email"] = "Email";
    DeliveryMethodInvoice["ElectronicInvoice"] = "ElectronicInvoice";
})(DeliveryMethodInvoice || (DeliveryMethodInvoice = {}));
export var CheckpointType;
(function (CheckpointType) {
    //Personalia
    CheckpointType["NameAndNationalId"] = "NameAndNationalId";
    CheckpointType["MaritalStatus"] = "MaritalStatus";
    CheckpointType["NameChange"] = "NameChange";
    CheckpointType["DriversLicense"] = "DriversLicense";
    CheckpointType["Children"] = "Children";
    CheckpointType["ResidentialAddresses"] = "ResidentialAddresses";
    CheckpointType["Migration"] = "Migration";
    CheckpointType["Cohabitants"] = "Cohabitants";
    CheckpointType["MilitaryService"] = "MilitaryService";
    CheckpointType["SanctionsList"] = "SanctionsList";
    CheckpointType["EuSanctionsList"] = "EuSanctionsList";
    CheckpointType["PoliticallyExposedPerson"] = "PoliticallyExposedPerson";
    //Financial
    CheckpointType["BanOnBusinessActivity"] = "BanOnBusinessActivity";
    CheckpointType["BeneficialOwner"] = "BeneficialOwner";
    CheckpointType["CorporateEngagement"] = "CorporateEngagement";
    CheckpointType["ExtendedCreditAndIncome"] = "ExtendedCreditAndIncome";
    CheckpointType["PaymentDefault"] = "PaymentDefault";
    CheckpointType["PersonalBankruptcy"] = "PersonalBankruptcy";
    CheckpointType["PersonalDebt"] = "PersonalDebt";
    CheckpointType["PreviousCreditChecks"] = "PreviousCreditChecks";
    CheckpointType["SoleProprietorship"] = "SoleProprietorship";
    CheckpointType["PropertyOwnership"] = "PropertyOwnership";
    CheckpointType["PublicTrusteeship"] = "PublicTrusteeship";
    CheckpointType["SeizureAttempts"] = "SeizureAttempts";
    CheckpointType["StudentDebt"] = "StudentDebt";
    CheckpointType["TaxableIncomeThreeYears"] = "TaxableIncomeThreeYears";
    CheckpointType["TaxableIncomeFiveYears"] = "TaxableIncomeFiveYears";
    CheckpointType["TaxableIncomeTwoYears"] = "TaxableIncomeTwoYears";
    CheckpointType["TaxableIncomeTenYears"] = "TaxableIncomeTenYears";
    CheckpointType["VehicleOwnership"] = "VehicleOwnership";
    CheckpointType["RepresentationProhibition"] = "RepresentationProhibition";
    CheckpointType["ExtendedFinancialMapping"] = "ExtendedFinancialMapping";
    CheckpointType["PartnerBackgroundCheck"] = "PartnerBackgroundCheck";
    CheckpointType["ExtendedCorporateEngagementMapping"] = "ExtendedCorporateEngagementMapping";
    //Resumé
    CheckpointType["Educations"] = "Educations";
    CheckpointType["HighestEducation"] = "HighestEducation";
    CheckpointType["TwoHighestEducations"] = "TwoHighestEducations";
    CheckpointType["Employment"] = "Employment";
    CheckpointType["Employer"] = "Employer";
    CheckpointType["ReferencePerson"] = "ReferencePerson";
    CheckpointType["OtherMerits"] = "OtherMerits";
    CheckpointType["Certifications"] = "Certifications";
    CheckpointType["CurrentEmployment"] = "CurrentEmployment";
    //Legal
    CheckpointType["DistrictCourts"] = "DistrictCourts";
    CheckpointType["CourtsOfAppeal"] = "CourtsOfAppeal";
    CheckpointType["AdministrativeCourts"] = "AdministrativeCourts";
    //Media
    CheckpointType["InternetAndMedia"] = "InternetOccurences";
    //International
    CheckpointType["Countries"] = "Countries";
    CheckpointType["InternationalResume"] = "InternationalResume";
    CheckpointType["CriminalRecords"] = "CriminalRecords";
    CheckpointType["InternationalResumeCurrentEmployment"] = "InternationalResumeCurrentEmployment";
})(CheckpointType || (CheckpointType = {}));
export var FileCategory;
(function (FileCategory) {
    FileCategory[FileCategory["CV"] = 0] = "CV";
    FileCategory[FileCategory["InternationalReport"] = 1] = "InternationalReport";
    FileCategory[FileCategory["Personalia"] = 2] = "Personalia";
    FileCategory[FileCategory["Economi"] = 3] = "Economi";
    FileCategory[FileCategory["CorporateEngagements"] = 4] = "CorporateEngagements";
    FileCategory[FileCategory["Legal"] = 5] = "Legal";
    FileCategory[FileCategory["MediaVerification"] = 6] = "MediaVerification";
    FileCategory[FileCategory["BKOfPartner"] = 7] = "BKOfPartner";
    FileCategory[FileCategory["Other"] = 8] = "Other";
})(FileCategory || (FileCategory = {}));
